(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advantages"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".advantages-section").forEach((section) => {
      const slider = section.querySelector(".swiper");
      const slides = section.querySelectorAll(".swiper-slide");

      if (!slider || slides.length <= 1) {
        return;
      }

      const breakpoint = window.matchMedia("(max-width: 1024px)");
      let swiperInstance = null;

      const enableSwiper = () => {
        swiperInstance = new Swiper(slider, {
          slidesPerView: "auto",
          pagination: {
            el: section.querySelector(".slider-pagination"),
            clickable: true,
          },
        });
      };

      const disableSwiper = () => {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      };

      const handleBreakpointChange = () => {
        if (breakpoint.matches && !swiperInstance) {
          enableSwiper();
        } else if (!breakpoint.matches && swiperInstance) {
          disableSwiper();
        }
      };

      handleBreakpointChange();

      breakpoint.addEventListener("change", handleBreakpointChange);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.benefits-section').forEach(section => {
        const slider = section.querySelector('.swiper');
        const slides = section.querySelectorAll('.swiper-slide');

        if (!slider || slides.length <= 1) {
            return;
        }

        const breakpoint = window.matchMedia('(max-width: 1024px)');
        let swiperInstance = null;

        const enableSwiper = () => {
            swiperInstance = new Swiper(slider, {
                slidesPerView: 'auto',
                pagination: {
                    el: section.querySelector('.slider-pagination'),
                    clickable: true,
                },
            });
        };

        const disableSwiper = () => {
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        };

        const handleBreakpointChange = () => {
            if (breakpoint.matches && !swiperInstance) {
                enableSwiper();
            } else if (!breakpoint.matches && swiperInstance) {
                disableSwiper();
            }
        };

        handleBreakpointChange();

        breakpoint.addEventListener('change', handleBreakpointChange);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.cards-grid-section').forEach(section => {
        const slider = section.querySelector('.swiper');
        const slides = section.querySelectorAll('.swiper-slide');

        if (!slider || slides.length <= 1) {
            return;
        }

        const breakpoint = window.matchMedia('(max-width: 1024px)');
        let swiperInstance = null;

        const enableSwiper = () => {
            swiperInstance = new Swiper(slider, {
                slidesPerView: 'auto',
                pagination: {
                    el: section.querySelector('.slider-pagination'),
                    clickable: true,
                },
            });
        };

        const disableSwiper = () => {
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        };

        const handleBreakpointChange = () => {
            if (breakpoint.matches && !swiperInstance) {
                enableSwiper();
            } else if (!breakpoint.matches && swiperInstance) {
                disableSwiper();
            }
        };

        handleBreakpointChange();

        breakpoint.addEventListener('change', handleBreakpointChange);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".faq-section").forEach((section) => {
      new ThemeTabs(section.querySelector('.theme-tabs'), 1025);

      section.querySelectorAll(".tabs-content.theme-accordion").forEach((accordion) => {
        new ThemeAccordion(accordion, 1024, true);
      });

      section.querySelectorAll('.theme-accordion .theme-accordion').forEach(accordion => {
        new ThemeAccordion(accordion, false, true);
      })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.features-section').forEach(section => {
        const slider = section.querySelector('.swiper');
        const slides = section.querySelectorAll('.swiper-slide');

        if (!slider || slides.length <= 1) {
            return;
        }

        const breakpoint = window.matchMedia('(max-width: 1024px)');
        let swiperInstance = null;

        const enableSwiper = () => {
            swiperInstance = new Swiper(slider, {
                slidesPerView: 'auto',
                pagination: {
                    el: section.querySelector('.slider-pagination'),
                    clickable: true,
                },
            });
        };

        const disableSwiper = () => {
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        };

        const handleBreakpointChange = () => {
            if (breakpoint.matches && !swiperInstance) {
                enableSwiper();
            } else if (!breakpoint.matches && swiperInstance) {
                disableSwiper();
            }
        };

        handleBreakpointChange();

        breakpoint.addEventListener('change', handleBreakpointChange);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
    const menu = document.querySelector('#menu-drawer');
    if (!menu) return;

    const togglers = Array.from(menu.querySelectorAll('.item-toggler'));

    togglers.forEach((button, index) => {
        const content = button.nextElementSibling;
        if (!content || !content.classList.contains('submenu')) return;

        if (!content.id) content.id = `MobileMenuSubmenu-${index + 1}`;
        button.setAttribute('aria-controls', content.id);
        button.setAttribute('aria-expanded', 'false');

        const heading = button.previousElementSibling;
        if (heading?.matches('a')) {
            heading.setAttribute('role', 'button');
            heading.setAttribute('aria-controls', content.id);
            heading.setAttribute('aria-expanded', 'false');
            heading.addEventListener('click', event => {
                event.preventDefault();
                toggleItem(button, content);
            });
        }

        button.addEventListener('click', () => toggleItem(button, content));
    });

    function toggleItem(button, content) {
        togglers.forEach(otherBtn => {
            const otherContent = otherBtn.nextElementSibling;
            if (
                otherBtn !== button &&
                otherBtn.classList.contains('open') &&
                otherContent?.classList.contains('submenu')
            ) {
                closeItem(otherBtn, otherContent);
            }
        });

        if (button.classList.contains('open')) {
            closeItem(button, content);
        } else {
            openItem(button, content);
        }
    }

    function setExpanded(button, expanded) {
        button.setAttribute('aria-expanded', String(expanded));
        const heading = button.previousElementSibling;
        if (heading?.matches('a')) heading.setAttribute('aria-expanded', String(expanded));
    }

    function openItem(button, content) {
        if (content.classList.contains('animating')) return;

        content.classList.add('animating');
        button.classList.add('open');
        setExpanded(button, true);

        requestAnimationFrame(() => {
            content.style.height = `${content.scrollHeight}px`;
            handleTransitionEnd(content, () => {
                content.classList.add('open');
            });
        });
    }

    function closeItem(button, content) {
        if (content.classList.contains('animating')) return;

        content.classList.add('animating');
        button.classList.remove('open');
        setExpanded(button, false);

        content.style.height = `${content.scrollHeight}px`;

        requestAnimationFrame(() => {
            content.style.height = '0px';
            handleTransitionEnd(content, () => {
                content.classList.remove('open');
            });
        });
    }

    function handleTransitionEnd(element, callback) {
        const onEnd = () => {
            element.removeEventListener('transitionend', onEnd);
            element.classList.remove('animating');
            callback?.();
            element.style.removeProperty('height');
        };
        element.addEventListener('transitionend', onEnd);
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-celebrate-section"] && !Shopify.designMode) return;
  try {
    
     document.querySelectorAll('.hero-celebrate-section .flipdown').forEach((el) => {
        const iso = (el.dataset.until || '').trim();
        const ms  = Date.parse(iso);
        if (Number.isNaN(ms) || !el.id) {
            console.warn('Countdown needs a valid ISO-8601 date and a unique id', el);
            return;
        }

        const targetTs = Math.floor(ms / 1000);

        const wrap = (() => {
            const sel = (el.dataset.wrap || '').trim();
            if (!sel) return el;
            try { return el.closest(sel) || el; } catch { return el; }
        })();

        const hideAtZero = ((el.dataset.hideAtZero || '').toString().toLowerCase() === 'true');
        const sectionEl = el.closest('.hero-celebrate-section') || wrap;
        if (hideAtZero && Math.floor(Date.now() / 1000) >= targetTs) {
            if (sectionEl) sectionEl.style.display = 'none';
            return;
        }

        new FlipDown(targetTs, el.id).start();
        const isKo = (el.dataset.lang || '').toLowerCase() === 'ko';
        const headingLabels = isKo ? ['일', '시간', '분', '초'] : ['Days', 'Hours', 'Minutes', 'Seconds'];
        el.querySelectorAll('.rotor-group-heading').forEach((heading, idx) => {
            heading.dataset.before = headingLabels[idx] || headingLabels[headingLabels.length - 1];
        });

        const secondsLeft = () => Math.max(0, targetTs - Math.floor(Date.now() / 1000));

        const applyView = (showSeconds) => {
            const groups   = el.querySelectorAll('.rotor-group');
            const headings = el.querySelectorAll('.rotor-group-heading');

            if (groups.length < 4 || headings.length < 4) return;

            [0,1,2,3].forEach(i => {
                groups[i].style.display = '';
                headings[i].style.display = '';
            });

            const isHoursMode = !!showSeconds;

            if (isHoursMode) {
                groups[0].style.display = 'none';
                headings[0].style.display = 'none';

                wrap.dataset.countdownView = 'hours';
                wrap.classList.add('is-hours-mode');
                wrap.classList.remove('is-days-mode');
            } else {
                groups[3].style.display = 'none';
                headings[3].style.display = 'none';

                wrap.dataset.countdownView = 'days';
                wrap.classList.add('is-days-mode');
                wrap.classList.remove('is-hours-mode');
            }

            wrap.dispatchEvent(new CustomEvent('countdown:viewchange', {
                bubbles: true,
                detail: { view: wrap.dataset.countdownView }
            }));
        };

        const initOnceReady = () => {
            if (el.querySelectorAll('.rotor-group').length < 4) return false;

            let showSeconds = secondsLeft() < 86400;
            applyView(showSeconds);

            const iv = setInterval(() => {
                const left = secondsLeft();
                const needShowSeconds = left < 86400;

                if (left <= 0) {
                    clearInterval(iv);
                    if (hideAtZero) {
                        if (sectionEl) sectionEl.style.display = 'none';
                        return;
                    }
                    applyView(true);
                    return;
                }

                if (needShowSeconds !== showSeconds) {
                    showSeconds = needShowSeconds;
                    applyView(showSeconds);
                }
            }, 1000);

            return true;
        };

        if (!initOnceReady()) {
            const mo = new MutationObserver(() => {
                if (initOnceReady()) mo.disconnect();
            });
            mo.observe(el, { childList: true, subtree: true });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.landing-gallery-section').forEach(section => {
        const slider = section.querySelector('.swiper');

        if (!slider) {
            return
        }

        new Swiper(slider, {
            slidesPerView: 'auto',
        });
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(".single-product-section").forEach((section) => {
      section.querySelectorAll(".theme-tabs").forEach((tab) => {
        new ThemeTabs(tab);
      });

      section.querySelectorAll(".theme-accordion").forEach((accordion) => {
        new ThemeAccordion(accordion, false, false);
      });
    });

    if (localStorage.getItem('theme-preview-popup')) {
      setTimeout(() => {
        const previewPopupLoadedFile = JSON.parse(localStorage.getItem('theme-preview-popup'));
        if (previewPopupLoadedFile) {
          publish(PUB_SUB_EVENTS.filestackFileChoiced, { data: previewPopupLoadedFile });
        }
        localStorage.removeItem('theme-preview-popup');
      }, 250)
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.reviews-slider-section').forEach(section => {
        const slider = section.querySelector('.swiper');
        const slides = section.querySelectorAll('.swiper-slide');

        if (!slider || slides.length <= 1) {
            return
        }

        let params = {
            slidesPerView: 'auto',
            navigation: {
                prevEl: section.querySelector('.slider-buttons .button-prev'),
                nextEl: section.querySelector('.slider-buttons .button-next'),
            }
        }

        new Swiper(slider, params);
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-preview-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const popup = document.querySelector(".theme-preview-popup");
    if (!popup) return;

    document.querySelectorAll(".theme-popup-preview-products").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        popup.classList.add("active")
      });
    });

    initStepLogic(popup);

    function initStepLogic(container) {
      const steps = [...container.querySelectorAll(".steps-content > li")];
      const stepButtons = [...container.querySelectorAll(".steps-btn")];
      let currentStepIndex = 0;

      function showStep(index) {
        steps.forEach((step, i) => step.classList.toggle("active", i === index));
        stepButtons.forEach((btn, i) => btn.classList.toggle("active", i === index));
        currentStepIndex = index;
      }

      stepButtons.forEach((btn, index) => {
        btn.addEventListener("click", () => {
          if (index <= currentStepIndex) showStep(index);
        });
      });

      const previewImage = container.querySelector("product-preview-addon");
      const v3Preview = container.querySelector("ccm-live-preview-v3");
      const useV3 = Boolean(v3Preview?.isActive);

      const step1 = steps[0];
      const uploadContainer = step1.querySelector(".upload-image");
      const imagePreviewContainer = step1.querySelector(".image-preview");
      const previewCloseBtn = imagePreviewContainer.querySelector(".image-preview-close");
      const nextBtn1 = step1.querySelector(".next-step");
      let uploadedImageUrl = null;

      function showPreview(url) {
        uploadedImageUrl = url;
        const img = imagePreviewContainer.querySelector("img");
        if (img) img.src = url;

        uploadContainer.classList.remove("active");
        imagePreviewContainer.classList.add("active");
        nextBtn1.classList.add("active");
      }

      function resetPreview() {
        const img = imagePreviewContainer.querySelector("img");
        if (img) img.src = "";
        imagePreviewContainer.classList.remove("active");
        uploadContainer.classList.add("active");
        nextBtn1.classList.remove("active");
        if (useV3) v3Preview.resetAndOpen();
        else picker?.open();
      }

      let picker = null;
      if (useV3) {
        container.classList.add('is-v3-active');
        v3Preview.mountExternalUploader(uploadContainer);
        v3Preview.addEventListener('ccm:live-preview-v3:file-selected', ({ detail }) => {
          if (detail?.thumbnailUrl) showPreview(detail.thumbnailUrl);
        });
      } else {
        const button=document.createElement('button');button.type='button';
        button.className='ccm-live-preview-v3__external-upload';
        button.textContent=v3Preview?.dataset.copyUpload || (/^ko(?:-|$)/i.test(document.documentElement.lang)?'사진 선택':'Choose photo');
        uploadContainer.replaceChildren(button);
        picker={open:async()=>{
          try {
            const choice=await window.NativePhotoCompat.choose();
            if (choice) publish(PUB_SUB_EVENTS.filestackFileChoiced,{data:window.NativePhotoCompat.metadata(choice)});
          } catch(error) {button.textContent=error.message || 'Photo upload is unavailable. Please retry.';}
        }};
        button.addEventListener('click',()=>picker.open());
      }

      subscribe(PUB_SUB_EVENTS.filestackFileChoiced, ({ data }) => {
        showPreview(data.url);
        localStorage.setItem('theme-preview-popup', JSON.stringify(data));
      });

      previewCloseBtn?.addEventListener("click", resetPreview);

      const step2 = steps[1];
      const nextBtn2 = step2.querySelector(".next-step");

      // step2.addEventListener("change", (e) => {
      //   if (e.target.matches('input[type="radio"]')) {
      //     nextBtn2.classList.add("active");
      //   }
      // });

       container.querySelectorAll('.crystal-type input[type="radio"]').forEach((radio) => {
         radio.addEventListener('change', () => {
           if (previewImage) previewImage.dataset.sku = radio.dataset.productSku;
           v3Preview?.setSelection({ crystal_sku: radio.dataset.productSku, base_sku: 'none' });
           container.querySelectorAll('[data-target="price-min"]').forEach((price) => {
             price.innerHTML = radio.dataset.priceMin;
           })
           container.querySelectorAll('[data-target="product-url"]').forEach((href) => {
             const productUrl = new URL(radio.value, window.location.origin);
             if (useV3) {
               productUrl.searchParams.set('view', 'korea-v2');
               productUrl.searchParams.set('preview_v3', '1');
             }
             href.setAttribute('href', productUrl.pathname + productUrl.search);
           })
           nextBtn2.classList.add("active");
         })
       });

      container.querySelectorAll(".next-step").forEach((btn, i) => {
        btn.addEventListener("click", () => {
          if (btn.classList.contains("active")) {
            showStep(i + 1);
          }
        });
      });

      showStep(0);
    }

    const closeBtn = popup.querySelector(".close-preview");
    closeBtn?.addEventListener("click", () => {
      popup.classList.remove("active");
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-select-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const popup = document.querySelector('.theme-select-popup');
    if (!popup) return;

    document.querySelectorAll('.theme-popup-select-products').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        popup.classList.add('active');
      });
    });

    popup.querySelectorAll('.crystal-type input[type="radio"]').forEach((input) => {
      input.addEventListener("change", (e) => {
        const container = e.target.closest('.theme-container');
        if (!container) return;
        const link_button = container.querySelector('[data-target="product_link"]');
        if (!link_button) return;
        link_button.setAttribute('href', e.target.value);
      })
    })

    document.addEventListener('click', e => {
      const isClickInside = popup.contains(e.target) || e.target.closest('.theme-button-primary');
      if (!isClickInside && popup.classList.contains('active')) {
        popup.classList.remove('active');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.video-reviews-section').forEach(section => {
        const mainSlider = section.querySelector('.main-slider .swiper');
        const slides = mainSlider?.querySelectorAll('.swiper-slide') || [];
        const thumbSlider = section.querySelector('.thumb-slider');

        if (!mainSlider || !thumbSlider) return;

        const pauseAllVideos = (except = null) => {
            slides.forEach(slide => {
                const video = slide.querySelector('video');
                if (video && video !== except) {
                    video.pause();
                    video.controls = false;
                }
                slide.classList.remove('video-playing');
            });
        };

        slides.forEach(slide => {
            const playBtn = slide.querySelector('.play-btn');
            const video = slide.querySelector('video');

            if (!playBtn || !video) return;

            const handlePause = () => {
                video.controls = false;
                slide.classList.remove('video-playing');
            };

            const handlePlay = () => {
                pauseAllVideos(video);
                video.play();
                video.controls = true;
                slide.classList.add('video-playing');
            };

            playBtn.addEventListener('click', () => {
                if (!video.paused && !video.ended) {
                    video.pause(); 
                } else {
                    handlePlay();
                }
            });

            video.addEventListener('click', () => {
                if (!video.paused && !video.ended) {
                    video.pause(); 
                }
            });

            video.addEventListener('pause', () => {
                handlePause();
            });

            video.addEventListener('ended', () => {
                handlePause();
            });
        });

        const thumbsInstance = new Swiper(thumbSlider, {
            slidesPerView: 'auto',
            watchSlidesProgress: true,
        });

        const mainInstance = new Swiper(mainSlider, {
            navigation: {
                nextEl: section.querySelector('.slider-buttons .button-next'),
                prevEl: section.querySelector('.slider-buttons .button-prev'),
            },
            pagination: {
                el: section.querySelector('.slider-pagination'),
                clickable: true,
            },
            thumbs: {
                swiper: thumbsInstance,
            },
            on: {
                slideChange: () => {
                    pauseAllVideos(); 
                },
            },
        });

        const breakpoint = window.matchMedia('(max-width: 1024px)');

        const handleBreakpointChange = () => {
            thumbsInstance.update(); 
        };

        breakpoint.addEventListener('change', handleBreakpointChange);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
